<template>
  <div class="app-customer-contract-dismissal-modal" v-if="!isContractDismisseld && !hasPendingDismissal">
    <div class="content">
      <slot name="txtBefore"></slot>
      <button class="text" @click="showModal"><slot name="btnOpenModal">Vertrag kündigen</slot></button>
      <slot name="txtAfter"></slot>
    </div>
    <SimonModal
      :is-visible="viewModal"
      @hide="closeModal"
      id="contract-dismissal-modal"
      btn-left-title="Ich will trotzdem kündigen"
      btn-right-title="Vertrag pausieren"
      @btnLeft="kuendigen"
      @btnRight="pausieren"
      show-footer-buttons
      size="large"
    >
      <template v-slot:modalTitle>
         <h1><slot name="modalHeader"></slot></h1>
      </template>
      <slot name="modalContent"></slot>
    </SimonModal>
  </div>
</template>

<script>

import customerContractState from '@/mixins/customerContractState'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'SelfServiceContractDismissalModal',
  data () {
    return {
      viewModal: false
    }
  },
  methods: {
    showModal () {
      if (this.contractPauseActive || this.contractPauseCreated) {
        window.location.href = this.dismissalFormUrl
      } else {
        this.viewModal = true
      }
    },
    closeModal () {
      this.viewModal = false
    },
    kuendigen () {
      this.startLoader()
      this.stopLoader()
      window.location.href = this.dismissalFormUrl
    },
    pausieren () {
      this.closeModal()
      document.dispatchEvent(new CustomEvent('openTariffBreak'))
    }
  },
  components: {
    SimonModal
  },
  mixins: [
    customerContractState()

  ],
  props: {
    dismissalFormUrl: {
      type: String,
      default: '#'
    }
  }
}
</script>
